import React from 'react'
import "../CSS/Partner.css";
function Partner() {
    return (
        <div className="partner">
            <div className="shop">
                จำหน่ายตามห้างสรรพสินค้าทั่วไป
                <img src="https://media.discordapp.net/attachments/445928139021877259/1181102895635111957/image_2222.png?ex=657fd6ca&is=656d61ca&hm=8d0c00988b46b00512622b5fa74ad166a39cc1587c8bf18bea6c861bbdd68c08&=&format=webp&quality=lossless&width=1440&height=327" alt="shopping mall" />
            </div>
            <div className="partner">
                <p>พบกับMeat Avatarได้ที่ร้านอาหารเพื่อสุขภาพชั้นนำทั่วไป</p>
                <img src="https://media.discordapp.net/attachments/445928139021877259/1181102895945494528/Component_11.png?ex=657fd6ca&is=656d61ca&hm=05e7e85e2774a75a3c592dbe3a96aefa73f5071d5b497b4a3d7e85f69ed52155&=&format=webp&quality=lossless&width=1440&height=330" alt="partnerlist" />
            </div>
        </div>
    )
}

export default Partner